var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 11.9286V9.07143L10.7143 6.57143V4.78571H15.7143V0.5H9.28571V6.57143L2.85714 9.07143V11.9286H0V20.5H7.14286V16.2143H12.8571V20.5H20V11.9286H17.1429ZM10 11.9286C9.21143 11.9286 8.57143 11.2886 8.57143 10.5C8.57143 9.71143 9.21143 9.07143 10 9.07143C10.7886 9.07143 11.4286 9.71143 11.4286 10.5C11.4286 11.2886 10.7886 11.9286 10 11.9286Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/SchoolIcon.4d20d67bccfc852f28d846d5847c4b1e.svg";
export { ForwardRef as ReactComponent };